import React, { useEffect, useState } from "react";
import { endpoints } from "../../constants/Endpoints";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  department as recoilDepart,
  exam as recoilExam,
  selectedDepartmentObject,
  selectedLanguage,
} from "../../providers/index";
import { instance } from "../../services/https/inceptors";
import EmptyIcon from "../../components/EmptyIcon/index";
import { LANGUAGES, MODULES } from "../../constants/Common";
import Actions from "../../components/Action/index";
import { useHistory } from "react-router-dom";
import ReactSelect from 'react-select';

const ExamAnalysis = () => {
  const { push } = useHistory();
  const [examAnalysis, setExamAnalysis] = useState();
  const exam = useRecoilValue(recoilExam).split("/")[1];
  const department = useRecoilValue(recoilDepart).split("/")[1];
  const selectedDepart = useRecoilValue(selectedDepartmentObject);
  const [currentLanguage, setCurrentLanguage] = useRecoilState(selectedLanguage);

  const getAllSyllabus = async () => {
    const res = await instance.get(
      `${endpoints.getAllExamAnalyis}?exam=${exam}&department=${department}`
    );
    setExamAnalysis(res.data);
  };

  useEffect(() => {
    getAllSyllabus();
  }, []);

  return (
    <div className="container">
      <div className="flex flex-col justify-center items-center my-4">
        <div
          className="d-flex justify-content-center rounded w-25 p-2 btn-hover c-pointer"
          onClick={() => push("/create-exam-analysis")}
        >
          Create Exam Analysis
        </div>

        <div className='mt-4'>
          <h6 className='mb-1 text-center'>Select Language</h6>
          <ReactSelect
            onChange={setCurrentLanguage}
            options={selectedDepart?.languages?.map((lang) => {
              const label = Object.keys(LANGUAGES).find(
                (key) => LANGUAGES[key] === lang
              );
              return {
                value: lang,
                label: label.replace(/^./, label[0].toUpperCase()),
              };
            })}
            value={currentLanguage}
            placeholder='Select Language'
            className='w-52'
          />
        </div>

      </div>

      <div className="mt-5 m-auto w-50">
        {examAnalysis?.length ? (
          <Actions
            language={currentLanguage}
            primary={true}
            type={MODULES.EXAM_ANALYSIS}
            data={examAnalysis}
            setData={setExamAnalysis}
          />
        ) : (
          <EmptyIcon />
        )}
      </div>
    </div>
  );
};

export default ExamAnalysis;
